module.exports = __webpack_public_path__ + "static/media/Agarose_Gel.871be9b2.svg";